<template>
  <v-row>
    <v-col cols="12" v-if="loadingInitial">
      <v-boilerplate type="card-heading, image, actions" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-card-text class="py-4 background">
          <v-row justify="space-between">
            <!-- customer -->
            <v-col cols="12" class="text-center py-5" v-if="!invoice.customer">
              <v-icon class="d-block" color="secondary" size="70">mdi-account</v-icon>
              <span class="d-block subtitle-1">Selecciona un cliente para continuar</span>
              <v-btn class="my-5" @click="dialogCustomer=true" outlined color="secondary">Seleccionar un cliente</v-btn>
            </v-col>
            <v-col cols="6" v-else>
              <v-toolbar color="transparent" flat height="48">
                <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Cliente</v-toolbar-title>
              </v-toolbar>
              <v-divider />
              <v-list class="transparent" two-line>
                <v-list-item>
                  <v-menu open-on-hover bottom offset-y :nudge-bottom="15" :close-delay="100" transition="slide-y-transition">
                    <template v-slot:activator="{on}">
                      <v-list-item-content v-on="on">
                        <v-list-item-title class="subtitle-2 text--secondary font-weight-medium">{{activeCustomer.name}}</v-list-item-title>
                        <v-list-item-subtitle class="text--primary">{{activeCurrency.id}} - {{activeCurrency.name}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                    <v-card>
                      <v-card-text>
                        <v-list class="v-list-form transparent">
                          <v-list-item class="px-0">
                            <v-list-item-title>ID Fiscal</v-list-item-title>
                            <v-list-item-subtitle v-if="activeCustomer.tax_id">{{activeCustomer.tax_id}}</v-list-item-subtitle>
                            <v-list-item-subtitle class="text--disabled font-italic" v-else>Sin ID Fiscal</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>Dirección</v-list-item-title>
                            <v-list-item-subtitle>{{activeCustomer.address}}</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>Estado</v-list-item-title>
                            <v-list-item-subtitle>{{activeCustomer.state.name}}</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>País</v-list-item-title>
                            <v-list-item-subtitle>{{activeCustomer.country.name}}</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>Email</v-list-item-title>
                            <v-list-item-subtitle>{{activeCustomer.email}}</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>Teléfono</v-list-item-title>
                            <v-list-item-subtitle v-if="activeCustomer.phone">{{activeCustomer.phone}}</v-list-item-subtitle>
                            <v-list-item-subtitle class="text--disabled font-italic" v-else>Sin teléfono</v-list-item-subtitle>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                  <v-list-item-action>
                    <v-btn @click="dialogCustomer=true" outlined color="secondary">Cambiar...</v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-divider />
            </v-col>
            <!-- end customer -->

            <v-col cols="6" v-if="invoice.customer">
              <v-list class="v-list-form transparent">
                <v-list-item class="py-1">
                  <v-list-item-title class="text-right text--secondary font-weight-medium">Tipo de factura</v-list-item-title>
                  <v-list-item-subtitle class="ml-4">
                    <v-select v-model="$v.invoice.document.$model" :error="$v.invoice.document.$error" :items="selectDocuments" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="30" background-color="white" single-line outlined dense hide-details>
                      <template v-slot:item="data">
                        <v-list-item-title class="font-weight-regular">{{data.item.name}}</v-list-item-title>
                      </template>
                    </v-select>
                  </v-list-item-subtitle>
                </v-list-item>

                <!-- invoice type tax settings fields -->
                <template v-if="activeDocument.country === 'MX'">
                  <v-list-item class="py-1">
                    <v-list-item-title class="text-right text--secondary font-weight-medium">Uso del CFDI</v-list-item-title>
                    <v-list-item-subtitle class="ml-4">
                      <v-select v-model="$v.invoice.tax_settings.mx_cfdi_use.$model" :error="$v.invoice.tax_settings.mx_cfdi_use.$error" :items="options.mxCfdiUses" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="30" background-color="white" single-line outlined dense hide-details>
                        <template v-slot:item="data">
                          <v-list-item-title class="font-weight-regular">{{data.item.name}}</v-list-item-title>
                        </template>
                      </v-select>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="py-1">
                    <v-list-item-title class="text-right text--secondary font-weight-medium">Forma de pago</v-list-item-title>
                    <v-list-item-subtitle class="ml-4">
                      <v-select v-model="$v.invoice.tax_settings.mx_payment_form.$model" :error="$v.invoice.tax_settings.mx_payment_form.$error" :items="options.mxPaymentForms" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="30" background-color="white" single-line outlined dense hide-details>
                        <template v-slot:item="data">
                          <v-list-item-title class="font-weight-regular">{{data.item.name}}</v-list-item-title>
                        </template>
                      </v-select>
                    </v-list-item-subtitle>
                  </v-list-item>
                </template>
                <!-- end invoice type tax settings fields -->

                <v-list-item class="py-1">
                  <v-list-item-title class="text-right text--secondary font-weight-medium">Fecha</v-list-item-title>
                  <v-list-item-subtitle class="ml-4">
                    <v-menu v-model="datePickerMenuInvoiceDate" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="$v.invoice.date.$model" :error="$v.invoice.date.$error" v-bind="attrs" v-on="on" background-color="white" outlined single-line dense readonly hide-details>
                          <template v-slot:append>
                            <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="$v.invoice.date.$model" @input="datePickerMenuInvoiceDate=false" min="2020-01-01" no-title :first-day-of-week="1" type="date" locale="es" width="270" color="primary">
                        <v-row class="py-2 px-6" align="center" justify="end">
                          <v-btn @click="() => { $v.invoice.date.$model=today; datePickerMenuInvoiceDate=false }" color="primary">Hoy</v-btn>
                        </v-row>
                      </v-date-picker>
                    </v-menu>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>

          <v-row class="mt-8" justify="space-between">
            <v-col cols="12">
              <v-toolbar color="transparent" flat height="20">
                <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Productos</v-toolbar-title>
                <v-spacer />
                <v-toolbar-items>
                  <v-row justify="end">

                    <!-- price selector -->
                    <product-plan-selector @selected="addInvoiceLineFromPlan" btn-class="mt-n2 mr-5" btn-icon="" btn-text="Agregar un precio" />
                    <!-- end price selector -->

                  </v-row>
                </v-toolbar-items>
              </v-toolbar>
            </v-col>
          </v-row>

          <v-divider />

          <v-row class="px-5" justify="space-between">
            <v-col cols="4" class="pl-2">
              <span class="text--secondary body-2 font-weight-medium">Producto</span>
            </v-col>
            <v-col cols="1" class="px-0">
              <span class="text--secondary body-2 font-weight-medium">Cantidad</span>
            </v-col>
            <v-col cols="1" class="px-0">
              <span class="text--secondary body-2 font-weight-medium">Unidad</span>
            </v-col>
            <v-col class="px-0 text-right" style="max-width: 110px">
              <span class="text--secondary body-2 font-weight-medium">Precio</span>
            </v-col>
            <v-col class="px-0 text-center" style="max-width: 50px">
              <span class="text--secondary body-2 font-weight-medium">Exento</span>
            </v-col>
            <v-col class="px-0 text-right" style="max-width: 110px">
              <span class="text--secondary body-2 font-weight-medium">Subtotal</span>
            </v-col>
            <v-col class="px-0 text-right" style="max-width: 30px"></v-col>
          </v-row>

          <v-divider />

          <template v-for="(d, i) in invoice.lines">
            <v-row class="v-sm-text-fields px-5" align="center" justify="space-between" :key="`line-${i}`">
              <v-col cols="4" class="pl-1">
                <v-text-field v-model.trim="$v.invoice.lines.$each[i].name.$model" :error="$v.invoice.lines.$each[i].name.$error" required maxlength="80" placeholder="Escribe un nombre..." background-color="white" height="16" outlined flat dense hide-details />
                <v-text-field v-model.trim="$v.invoice.lines.$each[i].description.$model" :error="$v.invoice.lines.$each[i].description.$error" required maxlength="512" placeholder="Escribe una descripción..." background-color="white" height="16" outlined flat dense hide-details />
              </v-col>
              <v-col cols="1" class="px-0">
                <v-text-field v-model.number="$v.invoice.lines.$each[i].quantity.$model" :error="$v.invoice.lines.$each[i].quantity.$error" oninput="this.value=this.value.replace(/[^0-9.]/g,'');" required maxlength="12" placeholder="0" background-color="white" height="16" outlined flat dense hide-details />

                <!-- line code -->
                <v-menu v-model="menusLineCode[i]" :min-width="210" :max-width="280" :close-on-content-click="false" offset-y :nudge-bottom="0" transition="slide-y-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" text color="primary" :ripple="false">
                      <template v-if="d.code"><template v-if="d.code_scheme">{{d.code_scheme}} - </template>{{d.code}}</template>
                      <template v-else>Código</template>
                    </v-btn>
                  </template>
                  <v-list class="pb-4 v-list-form v-sm-text-fields">
                    <v-list-item>
                      <v-list-item-title class="body-2 text--secondary font-weight-medium">Tipo <v-chip class="ml-1" color="secondary" x-small>Opcional</v-chip></v-list-item-title>
                      <v-list-item-title class="body-2 text--secondary font-weight-medium">Código</v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title>
                        <v-text-field v-model.trim="d.code_scheme" :error="$v.invoice.lines.$each[i].code_scheme.$error" maxlength="10" placeholder="SKU" background-color="white" height="26" outlined single-line solo flat dense hide-details />
                      </v-list-item-title>
                      <v-list-item-title>
                        <v-text-field v-model.trim="d.code" :error="$v.invoice.lines.$each[i].code.$error" maxlength="32" background-color="white" height="26" outlined single-line solo flat dense hide-details />
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <!-- end line code -->

              </v-col>
              <v-col cols="1" class="px-0">
                <v-text-field class="mb-9" v-model.trim="d.unit_label" :error="$v.invoice.lines.$each[i].unit_label.$error" maxlength="4" placeholder="C/U" background-color="white" height="16" outlined flat dense hide-details />
              </v-col>
              <v-col class="px-0 text-right" style="max-width: 110px">
                <v-text-field v-model.number="$v.invoice.lines.$each[i].amount.$model" :error="$v.invoice.lines.$each[i].amount.$error" oninput="this.value=this.value.replace(/[^0-9.]/g,'');" required maxlength="12" placeholder="0" single-line background-color="white" height="16" reverse outlined flat dense hide-details />
                <!-- line discount -->
                <v-menu v-model="menusLineDiscount[i]" :min-width="210" :max-width="210" :close-on-content-click="false" offset-y :nudge-bottom="0" transition="slide-y-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-1" v-bind="attrs" v-on="on" text :color="$v.invoice.lines.$each[i].discount.$error ? 'red' : 'primary'" :ripple="false">
                      <template v-if="d.discount">
                        <template v-if="d.discount_scheme === '%'">- {{d.discount}}{{d.discount_scheme}}</template>
                        <template v-if="d.discount_scheme === '$'">
                          <template v-if="activeCurrency.id">- {{d.discount | currency(activeCurrency.id)}} {{activeCurrency.id}}</template>
                          <template v-else>- {{d.discount}}</template>
                        </template>
                      </template>
                      <template v-else>Descuento</template>
                    </v-btn>
                  </template>
                  <v-list class="pb-4 v-list-form v-sm-text-fields">
                    <v-list-item>
                      <v-list-item-title class="body-2 text--secondary font-weight-medium">Tipo</v-list-item-title>
                      <v-list-item-subtitle class="body-2 text--secondary font-weight-medium">Valor</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title>
                        <v-select class="mr-1" v-model="d.discount_scheme" :items="discountSchemes" item-text="name" item-value="value" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="16" solo outlined flat dense hide-details>
                          <template v-slot:selection="{ item }"><span class="px-1 ml-1">{{item.value}}</span></template>
                        </v-select>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <v-text-field v-model.number="$v.invoice.lines.$each[i].discount.$model" :error="$v.invoice.lines.$each[i].discount.$error" oninput="this.value=this.value.replace(/[^0-9]/g,'');" background-color="white" height="26" outlined single-line solo flat dense hide-details />
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <!-- end line discount -->
              </v-col>
              <v-col class="px-0 text-center" style="max-width: 50px">
                <v-switch class="mt-0 mb-9 mr-n2 d-inline-block" v-model="d.exempt" :disabled="!activeDocument.has_taxes" dense hide-details />
              </v-col>
              <v-col class="px-0 text-right" style="max-width: 110px">
                <span class="d-block mt-0 mb-9 text--secondary body-2 font-weight-medium">
                  <template v-if="$v.invoice.lines.$each[i].amount.$error || $v.invoice.lines.$each[i].discount.$error || $v.invoice.lines.$each[i].quantity.$error">-</template>
                  <template v-else>{{aggregations.lines[i].subtotal | currency(activeCurrency.id)}} {{activeCurrency.id}}</template>
                </span>
              </v-col>
              <v-col class="px-0 text-right" style="max-width: 30px">
                <v-btn class="mt-0 mb-9" @click="invoice.lines.splice(i, 1)" :disabled="invoice.lines.length === 1" min-width="20" max-width="20" min-height="28" max-height="28" text color="red" :ripple="false"><v-icon size="20">mdi-delete</v-icon></v-btn>
              </v-col>
            </v-row>
            <v-divider :key="`divider-${i}`" />
          </template>

          <v-row class="px-4" no-gutters>
            <v-col class="text-left">
              <v-btn @click="addInvoiceLine" text color="primary" :ripple="false"><v-icon left>mdi-plus</v-icon>Agregar un producto</v-btn>
            </v-col>
          </v-row>

          <!-- summary -->
          <v-row align="center" justify="end">
            <v-col cols="5">
              <v-list class="v-list-form pa-0 transparent">
                <v-list-item class="py-0">
                  <v-list-item-title>Subtotal</v-list-item-title>
                  <v-list-item-subtitle class="text-right font-weight-medium">
                    <template v-if="linesWithAmountsError.length">-</template>
                    <template v-else>{{aggregations.subtotal | currency(activeCurrency.id)}}</template>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="py-0">
                  <v-list-item-title>Descuento</v-list-item-title>
                  <v-list-item-subtitle class="text-right">
                    <v-row class="px-3 v-sm-text-fields" align="center" justify="end">
                      <v-col cols="3">
                        <v-select class="mr-1" v-model="invoice.discount_scheme" :items="discountSchemes" item-text="name" item-value="value" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="16" solo outlined flat dense hide-details>
                          <template v-slot:selection="{ item }"><span class="px-1 ml-1">{{item.value}}</span></template>
                        </v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field v-model.number="$v.invoice.discount.$model" :error="$v.invoice.discount.$error" oninput="this.value=this.value.replace(/[^0-9]/g,'');" required maxlength="20" placeholder="0" background-color="white" height="16" solo outlined flat dense reverse hide-details />
                      </v-col>
                    </v-row>
                    <span v-if="aggregations.discount && invoice.discount_scheme === '%'">{{aggregations.discount | number}}</span>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="py-0 text-right" v-if="!$v.invoice.discount.maxAmount || !$v.invoice.discount.maxPercent">
                  <v-list-item-title class="red--text" v-if="!$v.invoice.discount.maxAmount">El descuento no puede superar el subtotal</v-list-item-title>
                  <v-list-item-title class="red--text" v-if="!$v.invoice.discount.maxPercent">El descuento no puede superar el 100%</v-list-item-title>
                </v-list-item>
                <template v-if="activeDocument.has_taxes_detail">
                  <v-divider class="ml-4 my-1" />
                  <v-list-item class="py-0">
                    <v-list-item-title>Exento</v-list-item-title>
                    <v-list-item-subtitle class="text-right font-weight-medium">
                      <template v-if="linesWithAmountsError.length">-</template>
                      <template v-else>{{aggregations.exempt | currency(activeCurrency.id)}}</template>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <template v-if="activeDocument.has_taxes">
                    <v-list-item class="py-0">
                      <v-list-item-title>Neto</v-list-item-title>
                      <v-list-item-subtitle class="text-right font-weight-medium">
                        <template v-if="linesWithAmountsError.length">-</template>
                        <template v-else>{{aggregations.amount | currency(activeCurrency.id)}}</template>
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-divider class="ml-4 my-1" />
                    <v-list-item>
                      <v-list-item-title>Impuestos ({{activeDocument.tax}}%)</v-list-item-title>
                      <v-list-item-subtitle class="text-right font-weight-medium">
                        <template v-if="linesWithAmountsError.length">-</template>
                        <template v-else>{{aggregations.taxes | currency(activeCurrency.id)}}</template>
                      </v-list-item-subtitle>
                    </v-list-item>
                  </template>
                </template>
                <v-divider class="ml-4 my-1" />
                <v-list-item class="py-0">
                  <v-list-item-title class="body-1 text--secondary font-weight-medium">Total</v-list-item-title>
                  <v-list-item-subtitle class="text-right body-1 font-weight-medium">
                    <template v-if="linesWithAmountsError.length">-</template>
                    <template v-else>{{aggregations.total | currency(activeCurrency.id)}} {{activeCurrency.id}}</template>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <!-- end summary -->

          <!-- payments -->
          <template v-if="instance.id">
            <v-toolbar color="transparent" flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Pago</v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-row class="px-4 v-sm-text-fields">
              <v-col cols="8">
                <v-radio-group v-model="invoice.collection_method">
                  <!-- manual with one fee -->
                  <v-radio value="deferred">
                    <template v-slot:label>
                      <div class="radioLabel--text font-weight-medium">Pago a través del portal de pagos por el total de la factura</div>
                    </template>
                  </v-radio>
                  <v-row class="pb-4" v-if="invoice.collection_method === 'deferred'">
                    <v-col cols="3" class="py-1 ml-8">
                      <span class="text--secondary font-weight-medium">Fecha de vencimiento</span>
                      <v-text-field v-model.number="$v.paymentDue.$model" :error="$v.paymentDue.$error" oninput="this.value=this.value.replace(/[^0-9]/g,'');" required maxlength="3" placeholder="0" suffix="días" height="36" background-color="white" outlined single-line dense hide-details />
                    </v-col>
                    <v-col cols="12" class="py-1 ml-8">
                      <span v-if="invoice.due_date">Fecha de pago para el {{invoice.due_date | date}}</span>
                    </v-col>
                  </v-row>
                  <!-- end manual with one fee -->

                  <!-- credit card -->
                  <v-radio value="automatically" :disabled="!sourcesDetail.id">
                    <template v-slot:label>
                      <div class="font-weight-medium">Hacer un cargo a una tarjeta de crédito / débito del cliente</div>
                    </template>
                  </v-radio>
                  <v-row class="pb-4" v-if="invoice.collection_method === 'automatically'">
                    <v-col class="ml-8">
                      <span v-if="sourcesDetail.id" class="text--secondary font-weight-medium">{{sourcesDetail.card.brand}} ••• ••• ••• {{sourcesDetail.card.last4}}</span>
                    </v-col>
                  </v-row>
                  <!-- end credit card -->
                </v-radio-group>
              </v-col>
            </v-row>
          </template>
          <!-- end payments -->

          <!-- additional information -->
          <v-row align="center" justify="space-between">
            <v-col cols="12">
              <v-toolbar color="transparent" flat height="20">
                <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Información adicional<v-chip class="ml-3 mt-n1" color="secondary" x-small>Opcional</v-chip></v-toolbar-title>
              </v-toolbar>
            </v-col>
          </v-row>
          <v-divider />
          <v-row class="v-sm-text-fields" align="center" justify="space-between">
            <v-col cols="12">
              <v-list class="v-list-form-extended transparent">
                <v-list-item>
                  <v-list-item-title class="text--secondary font-weight-medium">Periodo de facturación</v-list-item-title>
                  <v-list-item-subtitle class="py-1">
                    <v-row no-gutters>
                      <v-col cols="3">
                        <v-menu v-model="datePickerMenuInvoicePeriodStart" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="$v.invoice.period_start.$model" :error="$v.invoice.period_start.$error" v-bind="attrs" v-on="on" prefix="desde" background-color="white" outlined single-line dense readonly hide-details>
                              <template v-slot:append>
                                <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="$v.invoice.period_start.$model" @input="datePickerMenuInvoicePeriodStart=false" no-title :first-day-of-week="1" type="date" locale="es" width="270" color="primary">
                            <v-row class="py-2 px-6" align="center" justify="space-between">
                              <v-btn @click="() => { $v.invoice.period_start.$model=null; datePickerMenuInvoicePeriodStart=false }" outlined>Limpiar</v-btn>
                              <v-btn @click="() => { $v.invoice.period_start.$model=today; datePickerMenuInvoicePeriodStart=false }" color="primary">Hoy</v-btn>
                            </v-row>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="3">
                        <v-menu v-model="datePickerMenuInvoicePeriodEnd" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field class="pa-0" v-model="$v.invoice.period_end.$model" :error="$v.invoice.period_start.$error" v-bind="attrs" v-on="on" prefix="hasta" background-color="white" outlined single-line dense readonly hide-details>
                              <template v-slot:append>
                                <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker v-model="$v.invoice.period_end.$model" @input="datePickerMenuInvoicePeriodEnd=false" no-title :first-day-of-week="1" type="date" locale="es" width="270" color="primary">
                            <v-row class="py-2 px-6" align="center" justify="space-between">
                              <v-btn @click="() => { $v.invoice.period_end.$model=null; datePickerMenuInvoicePeriodEnd=false }" outlined>Limpiar</v-btn>
                              <v-btn @click="() => { $v.invoice.period_end.$model=today; datePickerMenuInvoicePeriodEnd=false }" color="primary">Hoy</v-btn>
                            </v-row>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title class="text--secondary font-weight-medium">Comentario</v-list-item-title>
                  <v-list-item-subtitle class="py-1">
                    <v-col cols="6">
                      <v-text-field v-model="invoice.note" hide-details background-color="white" outlined required single-line dense />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title class="pt-2 text--secondary font-weight-medium">Referencias</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" class="px-6 py-0">
              <v-row no-gutters v-if="invoice.references.length" >
                <v-col class="py-0 ml-1" cols="2">
                  <span class="body-2 text--secondary">Fecha</span>
                </v-col>
                <v-col class="py-0" cols="3">
                  <span class="body-2 text--secondary">Documento</span>
                </v-col>
                <v-col class="py-0" cols="2">
                  <span class="body-2 text--secondary">Identificador</span>
                </v-col>
                <v-col class="py-0" cols="4">
                  <span class="body-2 text--secondary">Descripción</span>
                </v-col>
              </v-row>
              <v-row v-for="(d, i) in invoice.references" :key="i" no-gutters>
                <v-col cols="2" class="py-0">
                  <v-menu v-model="datePickerMenuInvoiceReferences[i]" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="$v.invoice.references.$each[i].date.$model" :error="$v.invoice.references.$each[i].date.$error" v-bind="attrs" v-on="on" readonly background-color="white" height="36" solo outlined flat dense hide-details>
                        <template v-slot:append>
                          <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="$v.invoice.references.$each[i].date.$model" @input="datePickerMenuInvoiceReferences[i]=false" no-title :first-day-of-week="1" type="date" locale="es" width="270" color="primary">
                      <v-row class="py-2 px-6" align="center" justify="space-between">
                        <v-btn @click="() => { $v.invoice.references.$each[i].date.$model=null; datePickerMenuInvoiceReferences[i]=false }" outlined>Limpiar</v-btn>
                        <v-btn @click="() => { $v.invoice.references.$each[i].date.$model=today; datePickerMenuInvoiceReferences[i]=false }" color="primary">Hoy</v-btn>
                      </v-row>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="3" class="py-0">
                  <v-select v-model="$v.invoice.references.$each[i].document.$model" :error="$v.invoice.references.$each[i].document.$error" :items="referencesList" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="36" solo outlined flat dense hide-details />
                </v-col>
                <v-col cols="2" class="py-0">
                  <v-text-field v-model.trim="$v.invoice.references.$each[i].serial.$model" :error="$v.invoice.references.$each[i].serial.$error" maxlength="18" background-color="white" height="36" solo outlined flat dense hide-details />
                </v-col>
                <v-col cols="4" class="py-0">
                  <v-text-field v-model.trim="$v.invoice.references.$each[i].description.$model" :error="$v.invoice.references.$each[i].description.$error" maxlength="36" background-color="white" height="36" solo outlined flat dense hide-details />
                </v-col>
                <v-col cols="1" class="py-0">
                  <v-btn class="mt-1" @click="invoice.references.splice(i, 1)" min-width="20" max-width="20" min-height="28" max-height="28" text color="red" :ripple="false"><v-icon size="20">mdi-delete</v-icon></v-btn>
                </v-col>
              </v-row>
              <v-row class="px-1" no-gutters>
                <v-col cols="12" class="py-0">
                  <v-btn text color="primary" :ripple="false" @click="addInvoiceReference"><v-icon left>mdi-plus</v-icon>Agregar referencia</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="py-2 pb-6" v-if="activeDocument && activeDocument.is_foreign">
            <v-col md="8">
              <v-list class="v-list-form v-sm-text-fields transparent">
                <v-list-item>
                  <v-list-item-title>
                    Tipo de cambio personalizado
                    <v-tooltip right max-width="280px" transition="scale-transition">
                      <template v-slot:activator="{on}">
                        <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                      </template>
                      <span>Establece un valor fijo para la conversión de moneda o deja este campo en blanco para que Piriod determine automáticamente la conversión de moneda según la fecha de la factura.</span>
                    </v-tooltip>
                  </v-list-item-title>
                  <v-list-item-subtitle class="py-1">
                    <v-col cols="8">
                      <v-text-field v-model="$v.invoice.custom_change.$model" :disabled="!activeDocument || !activeDocument.is_foreign" :error="$v.invoice.custom_change.$error" :prefix="`1 ${activeCurrency.id} es igual a`" suffix="CLP" background-color="white" outlined required single-line dense maxlength="60" persistent-hint hide-details />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <!-- end additional information -->
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <template v-if="instance.id">
            <span class="body-2">Borrador guardado {{instance.updated | dateFromNow}}</span>
            <v-btn class="ml-3" @click="destroyInvoice" :disabled="loadingSave || loadingFinalize" text color="primary" :ripple="false"><v-icon small>mdi-delete</v-icon>Eliminar borrador</v-btn>
          </template>
          <v-spacer />
          <v-btn @click="updateInvoice('invoice', true)" :disabled="!instance.id" :loading="loadingSave || loadingFinalize" outlined>Guardar y salir</v-btn>
          <v-btn @click="updateInvoice('invoice'), finalizeInvoice()" :disabled="!instance.id" :loading="loadingSave || loadingFinalize" color="primary">Crear factura</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <!-- dialog customer -->
    <v-dialog v-model="dialogCustomer" width="600" persistent scrollable no-click-animation>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Seleccionar un cliente</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="pr-1">
                <v-btn class="ml-3" @click="dialogCustomer=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-subtitle class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" class="px-3 py-1">
              <v-text-field v-model="customerQuery" background-color="white" outlined required single-line dense placeholder="Escribe para buscar un cliente..." hide-details />
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-divider/>
        <v-card-text class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" class="text-left">
              <v-skeleton-loader v-if="$store.state.customers.retrieveLoader" transition="fade-transition" type="list-item" />
              <template v-else>
                <template v-if="customersList.length">
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="d in customersList" :key="d.id" @click="setCustomer(d)" style="cursor: pointer">
                          <td>
                            <span class="body-1 text--secondary font-weight-medium">{{d.name}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
                <v-col v-else class="text-center py-5">
                  <v-icon color="secondary" size="70">mdi-close-circle</v-icon>
                  <span class="d-block subtitle-1">No existen clientes</span>
                </v-col>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end dialog customer -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { decimal, maxLength, minValue, numeric, required, requiredIf } from 'vuelidate/lib/validators'
import { clReferences, mxCfdiUses, mxPaymentForms } from '@/collections/documents'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import ProductPlanSelector from '@/components/subscription/ProductPlanSelector'
import TaxAgencyViewMixin from '@/mixins/TaxAgencyViewMixin'

import cloneDeep from 'lodash/cloneDeep'
import debounce from 'lodash/debounce'
import moment from 'moment'

let prevRoute = null

export default {
  name: 'invoice-create',
  mixins: [
    GenericViewMixin,
    TaxAgencyViewMixin
  ],
  inject: ['theme'],
  components: {
    ProductPlanSelector,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  data: () => ({
    activeCustomer: {},
    aggregations: {
      lines: [
        {
          subtotal: 0
        }
      ],
      amount: 0,
      exempt: 0,
      subtotal: 0,
      discount: 0,
      taxes: 0,
      total: 0
    },
    customerQuery: '',
    datePickerMenuInvoiceDate: false,
    datePickerMenuInvoiceReferences: [false],
    datePickerMenuInvoicePeriodStart: false,
    datePickerMenuInvoicePeriodEnd: false,
    dialogCustomer: false,
    discountSchemes: [
      { name: 'Porcentaje', value: '%' },
      { name: 'Monto', value: '$'}
    ],
    invoice: {
      currency: null,
      customer: null,
      custom_change: null,
      document: null,
      number: 0,
      collection_method: 'deferred',
      date: '',
      due_date: null,
      discount: 0,
      discount_scheme: '%',
      period_start: null,
      period_end: null,
      lines: [
        {
          name: '',
          exempt: false,
          unit_label: '',
          amount: null,
          quantity: 1,
          discount: 0,
          discount_scheme: '%',
          tax: null,
          tax_percent: null
        }
      ],
      payments: [],
      references: [],
      tax_settings: {
        mx_cfdi_use: '',
        mx_payment_form: ''
      }
    },
    invoiceClone: {},
    loadingInitial: false,
    loadingSave: false,
    loadingFinalize: false,
    menusLineCode: [],
    menusLineDiscount: [],
    options: {
      clReferences: clReferences,
      mxCfdiUses: mxCfdiUses,
      mxPaymentForms: mxPaymentForms
    },
    paymentDue: 30,
    selectDocuments: [],
    sourcesDetail: {}
  }),
  computed: {
    activeDocument () {
      return this.documents.find(d => d.id === this.invoice.document) || {}
    },
    activeCurrency () {
      return this.currencies.find(c => c.id === this.activeCustomer.currency) || {}
    },
    aggregationsSource () {
      return {
        discount_scheme: this.invoice.discount_scheme,
        discount: this.invoice.discount,
        lines: this.invoice.lines.map(line => {
          return {
            amount: line.amount,
            discount: line.discount,
            discount_scheme: line.discount_scheme,
            exempt: line.exempt,
            quantity: line.quantity
          }
        })
      }
    },
    handledErrors () {
      return this.baseHandledErrors.concat([
        {
          action: 'Cargar folios',
          message: `La cuenta no tiene un folio válido para ${this.activeDocument.name}.`,
          route: { name: 'BillersBuiltIn', query: { ref: 'folios' } },
          snippet: 'not have a valid folio'
        }
      ])
    },
    linesWithAmountsError () {
      const lines = this.$v.invoice.lines
      return this.invoice.lines.filter((l, i) => lines.$each[i].amount.$error || lines.$each[i].discount.$error || lines.$each[i].quantity.$error)
    },
    ...mapState({
      customersList: state => state.customers.customersList,
      documents: state => state.generals.documentsList,
      instance: state => state.invoices.invoicesDetail,
      referencesList: state => state.generals.referencesList
    })
  },
  beforeRouteEnter (to, from, next) {
    prevRoute = from.name
    next()
  },
  created () {
    this.$store.dispatch('generals/LIST', {
      resource: 'generals/references',
      query: {
        page_size: 500
      }
    })
    this.$store.dispatch('generals/LIST', {
      resource: 'generals/documents',
      query: {
        country__id__in: `${this.account.country.id}, US`,
        is_sale: 'True'
      }
    })
    .then(() => {
      this.selectDocuments = []
      // generic documents
      const generics = this.documents.filter(d => d.country !== this.account.country.id)
      this.selectDocuments.push({ header: 'Genéricos' })
      this.selectDocuments = [...this.selectDocuments, ...generics]
      // local documents
      const sameCountry = this.documents.filter(d => d.country === this.account.country.id)
      if (sameCountry.length) {
        this.selectDocuments.push({ divider: true })
        this.selectDocuments.push({ header: this.account.country.name })
        this.selectDocuments = [...this.selectDocuments, ...sameCountry]
      }
    })
    if (this.$route.name === 'InvoiceCreate') {
      this.$store.commit('invoices/SET_DETAIL', {
        response: { data: {}, config: {} },
        resource: 'invoices',
        loader: false
      })
      this.invoice.date = this.today
      this.invoice.due_date = moment(this.today).add(30, 'days').format('YYYY-MM-DD')
    } else {
      if (prevRoute !== 'InvoiceCreate') {
        this.loadingInitial = true
      }
      this.$store.dispatch('invoices/RETRIEVE', {
        resource: 'invoices',
        id: this.$route.params.id
      })
      .then((response) => {
        if (this.instance.status === 'draft') {
          const data = cloneDeep(response.data)
          // assign id in nested attributes
          this.activeCustomer = data.customer
          data.customer = data.customer.id
          data.document = data.document.id
          if (data.payments.length) {
            data.payments.forEach((p, i) => {
              data.payments[i].customer = p.customer.id
            })
          }
          this.invoice = data
          this.paymentDue = moment(this.invoice.due_date).diff(moment(this.invoice.date), 'days')
        } else {
          this.$router.push({ name: 'InvoiceRetrieve', params: { id: this.instance.id } })
        }
      })
      .finally(() => {
        this.loadingInitial = false
      })
    }
  },
  watch: {
    activeDocument (newer, older) {
      const setExemptLines = (val) => {
        this.invoice.lines.forEach((line, index) => {
          this.invoice.lines[index].exempt = val
        })
      }
      if (this.activeDocument.has_taxes && !older.has_taxes) {
        setExemptLines(false)
      } else if (!this.activeDocument.has_taxes && older.has_taxes) {
        setExemptLines(true)
      }
      this.setAggregations()

      // country regulatory
      if (newer.country && older.country && (newer.country !== older.country)) {
        // assign specific tax settings for MX
        if (newer.country === 'MX') {
          this.invoice.tax_settings.mx_cfdi_use = this.invoice.tax_settings.mx_cfdi_use || 'G03'
          this.invoice.tax_settings.mx_payment_form = this.invoice.tax_settings.mx_payment_form || '99'
        }

        // assing specific tax settings for another regulations
      }
    },
    aggregationsSource: {
      handler () {
        this.setAggregations()
      },
      deep: true
    },
    customerQuery () {
      this.debounceMethod(this.getCustomers)
    },
    dialogCustomer () {
      if (this.dialogCustomer) {
        this.getCustomers()
      }
    },
    paymentDue () {
      this.setPayment()
    },
    'invoice.collection_method' () {
      this.setPayment()
    },
    invoice: {
      handler: debounce(function () {
        this.invoiceClone = cloneDeep(this.invoice)
        if (this.$route.name === 'InvoiceUpdate') {
          this.updateInvoice('invoiceClone')
        } else {
          this.createInvoice()
        }
      }, 700),
      deep: true
    }
  },
  methods: {
    addInvoiceLine () {
      this.invoice.lines.push({
        amount: null,
        exempt: !this.activeDocument.has_taxes,
        discount: 0,
        discount_scheme: '%',
        name: '',
        quantity: 1,
        tax: null,
        tax_percent: null,
        unit_label: ''
      })
    },
    addInvoiceLineFromPlan (plan) {
      this.invoice.lines.push({
        amount: plan.amount,
        exempt: !this.activeDocument.has_taxes,
        description: plan.description,
        discount: 0,
        discount_scheme: '%',
        name: plan.name,
        quantity: 1,
        tax: null,
        tax_percent: null,
        unit_label: ''
      })
    },
    addInvoiceReference () {
      this.invoice.references.push({
        date: null,
        document: '',
        serial: '',
        description: ''
      })
    },
    createInvoice () {
      this.$v.invoiceClone.$touch()
      if (this.$v.invoiceClone.$invalid) {
        return false
      }
      const payload = cloneDeep(this.invoice)

      // reset custom change
      if (!this.activeDocument.is_foreign || !payload.custom_change) {
        payload.custom_change = null
      }

      if (['automatically', 'deferred'].includes(this.invoice.collection_method)) {
        delete payload.payments
      }
      this.loadingSave = true
      this.$store.dispatch('invoices/CREATE', {
        resource: 'invoices',
        payload: payload
      })
      .then((response) => {
        this.invoice = cloneDeep(response.data)
        this.invoice.document = this.invoice.document.id
        this.$router.replace(`/invoices/${this.instance.id}/edit`)
      })
      .finally(() => {
        this.loadingSave = false
      })
    },
    destroyInvoice () {
      if (this.invoice.status !== 'draft') {
        return false
      }
      this.$dialog.warning({
        title: 'Eliminar documento',
        text: `
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('invoices/DESTROY', {
                resource: 'invoices',
                id: this.instance.id
              })
              .then(() => {
                this.$router.push({ name: 'InvoiceList' })
              })
              .catch(() => {
                this.$dialog.message.error()
              })
            }
          }
        ]
      })
    },
    finalizeInvoice () {
      this.$v.invoice.$touch()
      if (this.$v.invoice.$invalid) {
        return false
      }
      this.$dialog.warning({
        title: 'Confirmar documento',
        text: `
          <span class="d-block mb-4">Al confirmar este documento, se:</span>
          <span class="d-block pl-6">1. Validará con la agencia fiscal de ${this.account.country.name}</span>
          ${this.invoice.collection_method === 'automatically' ? '<span class="d-block pl-6">2. Cargará el total al método de pago del cliente</span>' : ''}
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [{
          color: 'primary',
          text: 'Continuar',
          handle: () => {
            this.loadingFinalize = true
            this.$store.dispatch('invoices/RETRIEVE', {
              resource: 'invoices',
              detail: 'finalize',
              id: this.instance.id,
              loader: false
            })
            .then(() => {
              if (this.instance.collection_method === 'automatically') {
                this.$store.dispatch('payments/CREATE', {
                  resource: 'payments',
                  payload: {
                    customer: this.instance.customer.id,
                    invoice: this.instance.id,
                    source: this.sourcesDetail.id
                  },
                  detail: 'authorize',
                  id: this.instance.payments[0].id
                })
                .then(() => {
                  this.$router.push({ name: 'InvoiceRetrieve', params: { id: this.instance.id } })
                })
                .catch(() => {
                  this.$dialog.message.info('La factura se ha creado pero el pago no se ha logrado procesar.')
                })
              } else {
                this.$router.push({ name: 'InvoiceRetrieve', params: { id: this.instance.id } })
              }
            })
            .catch((error) => {
              const errorData = error.response.data
              if (errorData.non_field_errors) {
                const handledError = this.handledErrors.find(he => errorData.non_field_errors.includes(he.snippet))
                if (handledError) {
                  this.$dialog.message.error(handledError.message, {
                    timeout: 10000,
                    actions: [{
                      text: handledError.action,
                      color: 'red darken-4',
                      handle: () => {
                        if (handledError.route) {
                          const routerData = this.$router.resolve(handledError.route)
                          window.open(routerData.href, '_blank')
                        }
                      }
                    }]
                  })
                } else {
                  this.$dialog.message.error(this.parseErrors(error.response.data))
                }
              } else {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              }
            })
            .finally(() => {
              this.loadingFinalize = false
            })
          }
        }]
      })
    },
    getCustomers () {
      if ([1, 2].includes(this.customerQuery.length)) {
        return false
      }
      const query = {
        page_size: 10
      }
      if (this.customerQuery.length >= 3) {
        query.name__icontains = this.customerQuery.toLowerCase()
      }
      this.$store.dispatch('customers/LIST', {
        resource: 'customers',
        query: query
      })
    },
    setAggregations () {
      const round = (this.activeCurrency.format && this.activeCurrency.format.precision === 0)
      let exempt = 0
      let amount = 0
      this.invoice.lines.forEach((line, i) => {
        this.aggregations.lines[i] = {
          subtotal: this.formatNumber((line.amount || 0) * (line.quantity || 0), round)
        }
        if (line.discount) {
          if (line.discount_scheme === '%') {
            this.aggregations.lines[i].subtotal -= this.aggregations.lines[i].subtotal * line.discount / 100
          } else {
            this.aggregations.lines[i].discount = this.formatNumber(line.discount, round)
            this.aggregations.lines[i].subtotal -= this.aggregations.lines[i].discount
          }
        }
        if (line.exempt || !this.activeDocument.has_taxes) {
          exempt += this.formatNumber(this.aggregations.lines[i].subtotal, round)
        } else {
          amount += this.formatNumber(this.aggregations.lines[i].subtotal, round)
        }
      })
      this.aggregations.exempt = this.formatNumber(exempt, round)
      this.aggregations.amount = this.formatNumber(amount, round)
      this.aggregations.subtotal = exempt + amount
      // discount
      if (this.invoice.discount) {
        if (this.invoice.discount_scheme === '%') {
          const percent = this.invoice.discount / 100
          this.aggregations.amount -= this.formatNumber(this.aggregations.amount * percent, round)
          this.aggregations.exempt -= this.formatNumber(this.aggregations.exempt * percent, round)
        } else if (this.invoice.discount_scheme === '$') {
          const amountPercent = this.aggregations.amount * 100 / this.aggregations.subtotal
          const exemptPercent = this.aggregations.exempt * 100 / this.aggregations.subtotal
          this.aggregations.amount -= this.formatNumber(this.invoice.discount * amountPercent / 100, round)
          this.aggregations.exempt -= this.formatNumber(this.invoice.discount * exemptPercent / 100, round)
        }
      }
      // taxes
      if (this.activeDocument.has_taxes) {
        if (this.activeDocument.has_lines_total) {
          const initialAmount = this.aggregations.amount
          this.aggregations.amount = this.formatNumber(initialAmount / ((this.activeDocument.tax / 100) + 1), round)
          this.aggregations.taxes = this.formatNumber(initialAmount - this.aggregations.amount, round)
        } else {
          this.aggregations.taxes = this.formatNumber(this.aggregations.amount * (this.activeDocument.tax / 100), round)
        }
      } else {
        this.aggregations.taxes = 0
      }
      // total
      this.aggregations.total = this.formatNumber(this.aggregations.exempt + this.aggregations.amount + this.aggregations.taxes, round)
    },
    setCustomer (customer) {
      this.activeCustomer = customer
      this.invoice.customer = customer.id
      this.customerQuery = ''
      this.dialogCustomer = false
      if (customer.sources.length) {
        this.$store.dispatch('payments/RETRIEVE', {
          resource: 'sources',
          id: customer.sources[0]
        })
        .then((response) => {
          this.sourcesDetail = response.data
        })
        .catch(() => {
          this.sourcesDetail = {}
        })
      } else {
        this.sourcesDetail = {}
        this.invoice.collection_method = 'deferred'
      }
    },
    setPayment () {
      if (this.invoice.collection_method === 'deferred') {
        this.invoice.due_date = moment(this.invoice.date).add(this.paymentDue, 'days').format('YYYY-MM-DD')
      }
    },
    updateInvoice (validate = 'invoice', exit = false) {
      this.$v[validate].$touch()
      if (this.$v[validate].$invalid) {
        return false
      }
      const payload = cloneDeep(this.invoice)
      delete payload.subtotal
      delete payload.amount
      delete payload.exempt
      delete payload.tax
      delete payload.tax_percent
      delete payload.total

      // reset custom change
      if (!this.activeDocument.is_foreign || !payload.custom_change) {
        payload.custom_change = null
      }

      if (['automatically', 'deferred'].includes(this.invoice.collection_method)) {
        delete payload.payments
      }
      this.loadingSave = true
      this.$store.dispatch('invoices/UPDATE', {
        resource: 'invoices',
        id: this.instance.id,
        payload: payload
      })
      .then(() => {
        if (exit) {
          this.$router.push({ name: 'InvoiceList' })
        }
      })
      .finally(() => {
        this.loadingSave = false
      })
    }
  },
  validations () {
    const invoice = {
      customer: {
        required
      },
      custom_change: {
        decimal
      },
      document: {
        required,
        currencyIsValid: function () {
          if (!this.invoice.customer) {
            return true
          }
          const currencies = this.activeDocument.currencies || []
          if (currencies.length) {
            return currencies.includes(this.activeCustomer.currency)
          }
          return false
        }
      },
      date: {
        required
      },
      period_start: {
        required: requiredIf(function () {
          return this.period_end
        })
      },
      period_end: {
        required: requiredIf(function () {
          return this.period_start
        })
      },
      discount: {
        maxAmount: function () {
          if (this.invoice.discount_scheme === '$') {
            return this.invoice.discount <= this.aggregations.subtotal
          }
          return true
        },
        maxPercent: function () {
          if (this.invoice.discount_scheme === '%') {
            return this.invoice.discount <= 100
          }
          return true
        },
        numeric,
        required
      },
      lines: {
        $each: {
          amount: {
            required,
            decimal
          },
          code: {
            maxLength: maxLength(32)
          },
          code_scheme: {
            maxLength: maxLength(10)
          },
          description: {
            maxLength: maxLength(512)
          },
          discount: {
            maxValue: function (value, line) {
              if (line.discount_scheme === '$') {
                return value <= line.quantity * line.amount
              }
              if (line.discount_scheme === '%') {
                return value <= 100
              }
              return true
            },
            minValue: minValue(0),
            numeric,
            required
          },
          name: {
            required,
            maxLength: maxLength(128)
          },
          quantity: {
            required,
            decimal
          },
          unit_label: {
            maxLength: maxLength(4)
          }
        }
      },
      payments: {
        $each: {
          date: {
            required
          },
          amount: {
            required,
            decimal
          },
          description: {
            required,
            maxLength: maxLength(40)
          }
        }
      },
      references: {
        $each: {
          date: {
            required
          },
          document: {
            required
          },
          serial: {
            required,
            maxLength: maxLength(18)
          },
          description: {
            maxLength: maxLength(64)
          }
        }
      },
      tax_settings: {
        mx_cfdi_use: {
          required: requiredIf(function () {
            return this.activeDocument.country === 'MX'
          }),
          maxLength: maxLength(3)
        },
        mx_payment_form: {
          required: requiredIf(function () {
            return this.activeDocument.country === 'MX'
          }),
          maxLength: maxLength(2)
        }
      }
    }
    return {
      invoice: invoice,
      invoiceClone: cloneDeep(invoice),
      paymentDue: {
        numeric
      }
    }
  }
}
</script>